export const getInventorySeparationList = state => {
    return state.list
}

export const getInventorySeparationDataProps = state => {
    return state.props
}

export const getInventorySeparationRequestList = state => {
    return state.request_list
}


// WEBPACK FOOTER //
// ./src/store/modules/inventorySeparation/getters.js